
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { FooterCellResource } from '../../../models/FooterCellResource';
import { FooterCellTypeResource } from '../../../models/FooterCellTypeResource';
import { FooterLinksResource } from '../../../models/FooterLinksResource';
import { FooterLinksTypeResource } from '../../../models/FooterLinksTypeResource';
import { FooterLinksListResource } from 'app/models/FooterLinksListResource';
import { FooterCellTypeListResource } from 'app/models/footerCellTypeListResource';
import { FooterLinksTypeListResource } from 'app/models/FooterLinksTypeListResource';
import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';
import { Validators, FormBuilder } from '@angular/forms';
import { EditColumnService } from 'app/homepage-configuration/footer-config/edit-column/edit-column.service';
import { FooterLinksResourceEdit } from 'app/models/FooterLinksResourceEdit';
import { DragulaService } from "ng2-dragula";
import { UtilsService } from "app/services/utils.service";
import { isNull } from 'util';
import { ElementRef } from "@angular/core";

@Component({
  selector: 'vbn-edit-column',
  providers: [EditColumnService],
  templateUrl: './edit-column.component.html',
  styleUrls: ['./edit-column.component.scss']
})
export class EditColumnComponent implements OnInit {
  dateNow: Date;
  cellParam: any;
  errorMessage: any;
  shwoFooterConfigOption: boolean = false;
  selected_language_link_add: string = "ro"
  selected_language_text_add: string = "ro"
  selected_language_link_edit: string = "ro"
  selected_language_text_edit: string = "ro"
  columnTitleLang: string = "ro"
  dragulaDrop: any;
  showConfirmation;
  showContent: boolean = false;

  showLinkOptions: boolean = false;
  showImageOptions: boolean = false;
  showTextOptions: boolean = false;
  showModalToAdd: boolean = false;
  showImageEdit: boolean = false;
  showLinkEdit: boolean = false;
  showTextEdit: boolean = false;
  contentShift: boolean = false;
  footerCellResource: FooterCellResource;
  footerLinksResource: FooterLinksResource;
  footerLinksResourceEdit: FooterLinksResourceEdit;
  footerCellTypeListResource: FooterCellTypeListResource;
  footerLinksTypeListResource: FooterLinksTypeListResource;
  footerLinksListResource: FooterLinksListResource;
  footerLinksListResourceActive: FooterLinksListResource;
  saveErrors: boolean = false;
  saveErrorsContentType: boolean = false;
  // Validation booleans for add
  saveErrorsLinks: boolean = false;
  saveErrorsImage: boolean = false;
  saveErrorsText: boolean = false;
  // Validation booleans for edit
  saveErrorsLinksEdit: boolean = false;
  saveErrorsImageEdit: boolean = false;
  saveErrorsTextEdit: boolean = false;
  imageValidationImage: boolean = false;
  showContentForAdd: boolean = false;
  showShiftBtn: boolean = false;
  showStyleOptions: boolean = false;
  showStyleOptions4Links: boolean = false;
  showStyleOptions4Image: boolean = false;
  showStyleOptions4Text: boolean = false;
  user = localStorage.getItem("_user");



  // cropped image cell //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImg: any;
  showButtonImage = true;
  showCropImage: boolean = false;
  resultImg: boolean = false;
  image: any = new Image();
  cropperSettings: CropperSettings;
  isInvalidImgSize1: boolean = false;
  showCropBtn1 = true;

  // cropped image link //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImgLink: any;
  showButtonImageLink = true;
  showCropImageLink: boolean = false;
  resultImgLink: boolean = false;
  cropperSettingsLinks: CropperSettings;
  isInvalidImgSize2: boolean = false;
  showCropBtn2 = true;

  // cropped image link edit //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImgLinkEdit: any;
  showButtonImageLinkEdit = true;
  showCropImageLinkEdit: boolean = false;
  resultImgLinkEdit: boolean = false;
  cropperSettingsLinksEdit: CropperSettings;
  isInvalidImgSize3: boolean = false;
  showCropBtn3 = true;

  // cropped image icon ADD Link //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImgIconAddLink: any;
  showButtonImageIconAddLink = true;
  showCropImageIconAddLink: boolean = false;
  resultImgIconAddLink: boolean = false;
  cropperSettingsIconAddLink: CropperSettings;
  isInvalidImgSize4: boolean = false;
  showCropBtn4 = true;

  // cropped image icon EDIT Link //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImgIconEditLink: any;
  showButtonImageIconEditLink = true;
  showCropImageIconEditLink: boolean = false;
  resultImgIconEditLink: boolean = false;
  cropperSettingsIconEditLink: CropperSettings;
  isInvalidImgSize5: boolean = false;
  showCropBtn5 = true;

  // cropped image icon ADD Text //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImgIconAddText: any;
  showButtonImageIconAddText = true;
  showCropImageIconAddText: boolean = false;
  resultImgIconAddText: boolean = false;
  cropperSettingsIconAddText: CropperSettings;
  isInvalidImgSize6: boolean = false;
  showCropBtn6 = true;

  // cropped image icon EDIT Text //////////////////////////////////////////////////////////////////////////////////////////////////////////
  croppedImgIconEditText: any;
  showButtonImageIconEditText = true;
  showCropImageIconEditText: boolean = false;
  resultImgIconEditText: boolean = false;
  cropperSettingsIconEditText: CropperSettings;
  isInvalidImgSize7: boolean = false;
  showCropBtn7 = true;

  columnFontFamily:string[] = ['Default','Arial','Calibri'];  //first position should be always 'Default' Value
  columnFontSizes:string[] = ['Default','14px','16px','18px'];  //first position should be always 'Default' Value
  styleCheckboxSelected : boolean = false;
  styleCheckboxSelected4Links : boolean = false;
  styleCheckboxSelected4Image : boolean = false;
  styleCheckboxSelected4Text : boolean = false;
  select_option: boolean = true;
  select_option_edit: boolean = true;
  show: boolean = true;
  showEdit: boolean = true;


  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  @ViewChild('cropper2', undefined) cropper2: ImageCropperComponent;
  @ViewChild('cropper3', undefined) cropper3: ImageCropperComponent;
  @ViewChild('cropper4', undefined) cropper4: ImageCropperComponent;
  @ViewChild('cropper5', undefined) cropper5: ImageCropperComponent;
  @ViewChild('cropper6', undefined) cropper6: ImageCropperComponent;
  @ViewChild('cropper7', undefined) cropper7: ImageCropperComponent;

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private editColumnService: EditColumnService,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dragulaService: DragulaService,
    private utilsService: UtilsService,
    private element: ElementRef
  ) {
    this.dragulaDrop = dragulaService.drop.subscribe((value) => {
      this.endShift(value)

    });
    this.footerLinksResource = new FooterLinksResource();
    this.footerLinksResourceEdit = new FooterLinksResourceEdit();
    this.footerLinksResource.footerLinksTypeResource = new FooterLinksTypeResource();
    this.footerCellResource = new FooterCellResource();
    this.footerCellResource.footerCellTypeResource = new FooterCellTypeResource();
    this.footerLinksTypeListResource = new FooterLinksTypeListResource();
    this.footerLinksTypeListResource.footerLinksTypeListResource = new Array();
    this.footerLinksListResource = new FooterLinksListResource();
    this.footerLinksListResourceActive = new FooterLinksListResource();
    this.footerCellTypeListResource = new FooterCellTypeListResource();
    this.footerCellTypeListResource.footerCellTypeListResource = new Array();
    this.footerLinksListResource.footerLinksListResource = new Array();
    this.footerLinksResource.openUrlBlank = false;
    this.dateNow = new Date();

    // cropper image for cell //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.croppedWidth = 20;
    this.cropperSettings.croppedHeight = 20;
    this.cropperSettings.compressRatio = 2.125;
    this.cropperSettings.canvasWidth = 200;
    this.cropperSettings.canvasHeight = 200;
    this.cropperSettings.keepAspect = false;
    this.cropperSettings.allowedFilesRegex = /.(jpe?g|png|gif)$/i;

    // cropper image for Links //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettingsLinks = new CropperSettings();
    this.cropperSettingsLinks.croppedWidth = 130;
    this.cropperSettingsLinks.compressRatio = 2.125;
    this.cropperSettingsLinks.canvasWidth = 200;
    this.cropperSettingsLinks.canvasHeight = 200;
    this.cropperSettingsLinks.keepAspect = false;

    // cropper image for Links edit //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettingsLinksEdit = new CropperSettings();
    this.cropperSettingsLinksEdit.croppedWidth = 130;
    this.cropperSettingsLinksEdit.compressRatio = 2.125;
    this.cropperSettingsLinksEdit.canvasWidth = 200;
    this.cropperSettingsLinksEdit.canvasHeight = 200;
    this.cropperSettingsLinksEdit.keepAspect = false;

    // cropper image for icon add link //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettingsIconAddLink = new CropperSettings();
    this.cropperSettingsIconAddLink.croppedWidth = 50;
    this.cropperSettingsIconAddLink.croppedHeight = 50;
    this.cropperSettingsIconAddLink.compressRatio = 2.125;
    this.cropperSettingsIconAddLink.canvasWidth = 200;
    this.cropperSettingsIconAddLink.canvasHeight = 200;
    this.cropperSettingsIconAddLink.keepAspect = true;

    // cropper image for icon edit link //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettingsIconEditLink = new CropperSettings();
    this.cropperSettingsIconEditLink.croppedWidth = 50;
    this.cropperSettingsIconEditLink.croppedHeight = 50;
    this.cropperSettingsIconEditLink.compressRatio = 2.125;
    this.cropperSettingsIconEditLink.canvasWidth = 200;
    this.cropperSettingsIconEditLink.canvasHeight = 200;
    this.cropperSettingsIconEditLink.keepAspect = true;

    // cropper image for icon add text //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettingsIconAddText = new CropperSettings();
    this.cropperSettingsIconAddText.croppedWidth = 50;
    this.cropperSettingsIconAddText.croppedHeight = 50;
    this.cropperSettingsIconAddText.compressRatio = 2.125;
    this.cropperSettingsIconAddText.canvasWidth = 200;
    this.cropperSettingsIconAddText.canvasHeight = 200;
    this.cropperSettingsIconAddText.keepAspect = true;

    // cropper image for icon edit text //////////////////////////////////////////////////////////////////////////////////////////////////////////
    this.cropperSettingsIconEditText = new CropperSettings();
    this.cropperSettingsIconEditText.croppedWidth = 50;
    this.cropperSettingsIconEditText.croppedHeight = 50;
    this.cropperSettingsIconEditText.compressRatio = 2.125;
    this.cropperSettingsIconEditText.canvasWidth = 200;
    this.cropperSettingsIconEditText.canvasHeight = 200;
    this.cropperSettingsIconEditText.keepAspect = true;

    this.croppedImg = {};
    this.croppedImgLink = {};
    this.croppedImgLinkEdit = {};
    this.croppedImgIconAddLink = {};
    this.croppedImgIconEditLink = {};
    this.croppedImgIconAddText = {};
    this.croppedImgIconEditText = {};



  }

  clear1() {
    this.croppedImg = {};
    this.cropper.reset();
    return;
  }

  clear2() {
    this.croppedImgLink = {};
    this.cropper2.reset();
    return;
  }

  clear3() {
    this.croppedImgLinkEdit = {};
    this.cropper3.reset();
    return;
  }

  clear4() {
    this.croppedImgIconAddLink = {};
    this.cropper4.reset();
    return;
  }

  clear5() {
    this.croppedImgIconEditLink = {};
    this.cropper5.reset();
    return;
  }

  clear6() {
    this.croppedImgIconAddText = {};
    this.cropper6.reset();
    return;
  }

  clear7() {
    this.croppedImgIconEditText = {};
    this.cropper7.reset();
    return;
  }


  configDisable() {

    this.shwoFooterConfigOption = false
    this.showImageOptions = false;
    this.showTextOptions = false;
    this.showLinkOptions = false;
  }

  showLink() {

    this.showImageOptions = false;
    this.showTextOptions = false;
    this.showLinkOptions = true;
  }

  showImage() {

    this.showTextOptions = false;
    this.showLinkOptions = false;
    this.showImageOptions = true;
  }

  showText() {

    this.showImageOptions = false;
    this.showLinkOptions = false;
    this.showTextOptions = true;
  }

  saveConfirm() {
    this.showModalToAdd = true;
  }

  back() {
    this._router.navigate([`/view-footer-columns`])
    // this.router.navigate(['/view-footer-columns/' + btoa('{ "locationIdSelected" : "' + this.addressParams.locationIdSelected + '"}')]);
  }

  ngOnInit() {
    this.getAllCellType();
    this.getAllLinksType();

    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['json'] != undefined) {
        this.cellParam = JSON.parse(atob(params['json']));
        console.log("eddd------------", this.cellParam)
        if (this.cellParam.rid != null) {
          this.getCellById(this.cellParam.rid);
        }
      }
    });
    if(isNull(this.footerCellResource.titleFontSize) || typeof(this.footerCellResource.titleFontSize) == 'undefined'){
      this.footerCellResource.titleFontSize = this.columnFontSizes[0];
    }
    if(isNull(this.footerCellResource.titleFontFamily) || typeof(this.footerCellResource.titleFontFamily) == 'undefined'){
      this.footerCellResource.titleFontFamily = this.columnFontFamily[0];
    }
  }

  ngOnDestroy(): void {
    this.dragulaDrop.unsubscribe();
  }



  // validari
  addColumnForm = this.fb.group({
    titleRoColumn: ['', [Validators.maxLength(100)]],
    titleEnColumn: [''],
    titleFrColumn: [''],
    titleDeColumn: [''],
    numberOfCells: ['', [Validators.required]],
    columnType: ['', [Validators.required]],
    titleFontFamily: ['', []],
    titleFontSize: ['', []],
    columnTopMargin: ['', []]

  })

  // VALIDATION FOR ADD
  showLinkOptionsForm = this.fb.group({
    columnLinkTextRo: ['', [Validators.required, Validators.maxLength(100), this.utilsService.NoWhitespaceValidator()]],
    columnLinkTextFr: [''],
    columnLinkTextEn: [''],
    columnLinkTextDe: [''],
    columnLinkUrl: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
    marginBottom: ['',''],
    fontFamily: ['',''],
    fontSize: ['','']

  })

  showImageOptionsForm = this.fb.group({
    columnImageUrl: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
    marginBottom: ['',''],
    fontFamily: ['',''],
    fontSize: ['','']
  })

  showTextOptionsForm = this.fb.group({
    columnTextRo: ['', [Validators.required, Validators.maxLength(150), this.utilsService.NoWhitespaceValidator()]],
    columnTextFr: [''],
    columnTextEn: [''],
    columnTextDe: [''],
    marginBottom: ['',''],
    fontFamily: ['',''],
    fontSize: ['','']
  })

  // VALIDATION FOR EDIT
  showLinkOptionsFormEdit = this.fb.group({
    columnLinkTextRo: ['', [Validators.required, Validators.maxLength(100), this.utilsService.NoWhitespaceValidator()]],
    columnLinkTextFr: [''],
    columnLinkTextEn: [''],
    columnLinkTextDe: [''],
    columnLinkUrl: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
    marginBottom: ['',''],
    fontFamily: ['',''],
    fontSize: ['','']
  })

  showImageOptionsFormEdit = this.fb.group({
    columnImageUrl: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
    marginBottom: ['',''],
    fontFamily: ['',''],
    fontSize: ['','']
  })

  showTextOptionsFormEdit = this.fb.group({
    columnTextRo: ['', [Validators.required, Validators.maxLength(150), this.utilsService.NoWhitespaceValidator()]],
    columnTextFr: [''],
    columnTextEn: [''],
    columnTextDe: [''],
    marginBottom: ['',''],
    fontFamily: ['',''],
    fontSize: ['','']
  })

  // metoda principala de salvare celula si date configurabile
  saveCell() {
    
    this.saveErrors = true
    if (!this.addColumnForm.valid) {
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return
    }
    if(this.footerCellResource.titleRo) {
      this.footerCellResource.titleRo = this.utilsService.WhiteSpacesRemover(this.footerCellResource.titleRo);
    }
    if(this.footerCellResource.titleDe) {
      this.footerCellResource.titleDe = this.utilsService.WhiteSpacesRemover(this.footerCellResource.titleDe);
    }
    if(this.footerCellResource.titleEn) {
      this.footerCellResource.titleEn = this.utilsService.WhiteSpacesRemover(this.footerCellResource.titleEn);
    }
    if(this.footerCellResource.titleFr) {
      this.footerCellResource.titleFr = this.utilsService.WhiteSpacesRemover(this.footerCellResource.titleFr);
    }
    /* this.footerCellResource.titleFr = this.utilsService.WhiteSpacesRemover(this.footerCellResource.titleFr); */
    if( !isNull(this.footerCellResource.columnTopMargin) &&  typeof(this.footerCellResource.columnTopMargin) != 'undefined'){
      this.footerCellResource.columnTopMargin += 'px';
    }
    if(isNull(this.footerCellResource.titleFontSize) || typeof(this.footerCellResource.titleFontSize) == 'undefined'){
      this.footerCellResource.titleFontSize = this.columnFontSizes[0];
    }
    if(isNull(this.footerCellResource.titleFontFamily) || typeof(this.footerCellResource.titleFontFamily) == 'undefined'){
      this.footerCellResource.titleFontFamily = this.columnFontFamily[0];
    }
    this.footerCellResource.userEmail = this.user;
    this.editColumnService.saveCellService(`/admin/footer/cell/edit`, this.footerCellResource)
      .subscribe(
        body => {
          this.footerCellResource = body;
          (this.footerCellResource.columnTopMargin)&&(this.footerCellResource.columnTopMargin = this.footerCellResource.columnTopMargin.split('px')[0])
          this.dateNow = new Date();
          this.getLinksByCellId(this.footerCellResource.rid);
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Column saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.clear1();
        },
        error => console.error(error))
  }

  // metoda ce aduce tipul de date din celula daca e newsletter sau configurabil
  getAllCellType() {
    this.editColumnService.getFooterCellTypeResource('/admin/footer/cellType/getAll')
      .subscribe(
        body => {
          this.footerCellTypeListResource = body;
        },
        error => this.errorMessage = <any>error)
  }

  getAllLinksType() {
    this.editColumnService.getLinkTypes('/admin/footer/linksType/getAll')
      .subscribe(
        body => {
          this.footerLinksTypeListResource = body;
        },
        error => this.errorMessage = <any>error)
  }

  getLinksByCellId(rid: number) {
    this.editColumnService.getLinksByCell('/admin/footer/links/getAllByCell/' + rid + "?email=" + this.user)
      .subscribe(
        body => {
          this.footerLinksListResource = body;
        },
        error => this.errorMessage = <any>error)
  }

  getCellById(rid: number) {
    this.editColumnService.getOne('/admin/footer/cell/getOne/' + rid+ "?email=" + this.user)
      .subscribe(
        body => {
          this.footerCellResource = body;
          if(isNull(this.footerCellResource.titleFontFamily)){
            this.footerCellResource.titleFontFamily = this.columnFontFamily[0];
          }
          if(isNull(this.footerCellResource.titleFontSize)){
            this.footerCellResource.titleFontSize = this.columnFontSizes[0];
          }
          (this.footerCellResource.columnTopMargin)&&(this.footerCellResource.columnTopMargin = this.footerCellResource.columnTopMargin.split('px')[0])

          if((this.footerCellResource.titleFontFamily && this.footerCellResource.titleFontFamily != this.columnFontFamily[0])
              || (this.footerCellResource.titleFontSize && this.footerCellResource.titleFontSize != this.columnFontSizes[0])
              || this.footerCellResource.columnTopMargin){
            this.showStyleOptions = true;
            this.styleCheckboxSelected = true;
          }
          if (this.footerCellResource.footerCellTypeResource.keyName == "configurable") {
            this.shwoFooterConfigOption = true;
            this.getLinksByCellId(this.cellParam.rid);
            this.getAllFooterLinksActive(this.cellParam.rid);
          }
          if (this.footerCellResource.imagePath != null && this.footerCellResource.imagePath != "" && this.footerCellResource.imagePath != undefined) {
            this.resultImg = true;
          }
          if (this.footerCellResource.footerCellTypeResource.rid == 2) {
            this.showContent = true;
          }
        },
        error => this.errorMessage = <any>error)
  }


  // metoda ce arata datele disponibile celulei configurabile
  showConfigOptionsMethod() {
    if (this.footerCellResource.footerCellTypeResource.rid == 2) {
      this.shwoFooterConfigOption = true;
      this.footerLinksResource = new FooterLinksResource();
    } else {
      this.configDisable();
    }
  }

  //metoda ce arata tipurile de link disponibile celulei configurabile
  showLinksTypeOptionMethod() {
    if (this.footerLinksResource.footerLinksTypeResource.rid == 1) {
      this.footerLinksResource.imageB64="";
      this.footerLinksResource.openUrlBlank = false;
      this.croppedImgLink = {};
      this.resultImgLink = false;
      this.saveErrorsImage = false;
      this.showImageOptionsForm.reset();      
      this.showImage();
    }
    if (this.footerLinksResource.footerLinksTypeResource.rid == 2) {
      this.footerLinksResource.imageB64="";
      this.footerLinksResource.openUrlBlank = false;
      this.croppedImgIconAddLink = {};
      this.resultImgIconAddLink = false;
      this.saveErrorsLinks = false
      this.showLinkOptionsForm.reset();
      this.showLink();
    }
    if (this.footerLinksResource.footerLinksTypeResource.rid == 3) {
      this.footerLinksResource.imageB64="";
      this.croppedImgIconAddText ={};
      this.resultImgIconAddText = false;
      this.saveErrorsText = false;
      this.showTextOptionsForm.reset();
      this.showText();
    }
    if( !isNull(this.footerLinksResource.marginBottom) &&  typeof(this.footerLinksResource.marginBottom) != 'undefined'){
      this.footerLinksResource.marginBottom += 'px';
    }
    if(isNull(this.footerLinksResource.fontFamily) || typeof(this.footerLinksResource.fontFamily) == 'undefined'){
      this.footerLinksResource.fontFamily = this.columnFontFamily[0];
    }
    if(isNull(this.footerLinksResource.fontSize) || typeof(this.footerLinksResource.fontSize) == 'undefined'){
      this.footerLinksResource.fontSize = this.columnFontSizes[0];
    }
  }

  // metoda ce salveaza optiunile coloanei text, imagine, link
  saveColumnOptions() {
    this.footerLinksResource.footerCellResource = this.footerCellResource;
    this.footerLinksResource.footerCellResource.titleRo = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.footerCellResource.titleRo);
    this.footerLinksResource.footerCellResource.titleFr = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.footerCellResource.titleFr);
    this.footerLinksResource.footerCellResource.titleDe = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.footerCellResource.titleDe);
    this.footerLinksResource.footerCellResource.titleEn = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.footerCellResource.titleEn);
    if (this.footerLinksResource.textRo || this.footerLinksResource.textFr || this.footerLinksResource.textEn) {
      this.footerLinksResource.textRo = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.textRo);
      this.footerLinksResource.textFr = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.textFr);
      this.footerLinksResource.textEn = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.textEn);
      this.footerLinksResource.textDe = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.textDe);
    }
    if (this.footerLinksResource.url) {
      this.footerLinksResource.url = this.utilsService.WhiteSpacesRemover(this.footerLinksResource.url);
    }

    if( !isNull(this.footerLinksResource.marginBottom) &&  typeof(this.footerLinksResource.marginBottom) != 'undefined'){
      this.footerLinksResource.marginBottom += 'px';
    }
    if(isNull(this.footerLinksResource.fontSize) || typeof(this.footerLinksResource.fontSize) == 'undefined'){
      this.footerLinksResource.fontSize = this.columnFontSizes[0];
    }
    if(isNull(this.footerLinksResource.fontFamily) || typeof(this.footerLinksResource.fontFamily) == 'undefined'){
      this.footerLinksResource.fontFamily = this.columnFontFamily[0];
    }
    this.footerLinksResource.userEmail = this.user;
    this.editColumnService.saveLinksResource(`/admin/footer/links/edit`, this.footerLinksResource)
      .subscribe(
        body => {
          this.footerLinksResource = new FooterLinksResource();
          this.showImageOptions = false;
          this.showTextOptions = false;
          this.showLinkOptions = false;
          this.getLinksByCellId(this.footerCellResource.rid);
          this.getAllFooterLinksActive(this.footerCellResource.rid);
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Column options saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
        },
        error => console.error(error))
  }

  saveColumnOptionsEdit() {
    // image = 1, link = 2, text = 3
    if (this.footerLinksResourceEdit.footerLinksTypeResource.rid == 2) {
      this.saveErrorsLinksEdit = true;
      if (!this.showLinkOptionsFormEdit.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }
    if (this.footerLinksResourceEdit.footerLinksTypeResource.rid == 1) {
      this.saveErrorsImageEdit = true;
      if (!this.showImageOptionsFormEdit.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }
    if (this.footerLinksResourceEdit.footerLinksTypeResource.rid == 3) {
      this.saveErrorsTextEdit = true;
      if (!this.showTextOptionsFormEdit.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }

    this.footerLinksResourceEdit.textRo = this.utilsService.WhiteSpacesRemover(this.footerLinksResourceEdit.textRo);
    this.footerLinksResourceEdit.textFr = this.utilsService.WhiteSpacesRemover(this.footerLinksResourceEdit.textFr);
    this.footerLinksResourceEdit.textDe = this.utilsService.WhiteSpacesRemover(this.footerLinksResourceEdit.textDe);
    this.footerLinksResourceEdit.textEn = this.utilsService.WhiteSpacesRemover(this.footerLinksResourceEdit.textEn);
    this.footerLinksResourceEdit.url = this.utilsService.WhiteSpacesRemover(this.footerLinksResourceEdit.url);

    if( !isNull(this.footerLinksResourceEdit.marginBottom) &&  typeof(this.footerLinksResourceEdit.marginBottom) != 'undefined'){
      this.footerLinksResourceEdit.marginBottom += 'px';
    }
    if(isNull(this.footerLinksResourceEdit.fontSize) || typeof(this.footerLinksResourceEdit.fontSize) == 'undefined'){
      this.footerLinksResourceEdit.fontSize = this.columnFontSizes[0];
    }
    if(isNull(this.footerLinksResourceEdit.fontFamily) || typeof(this.footerLinksResourceEdit.fontFamily) == 'undefined'){
      this.footerLinksResourceEdit.fontFamily = this.columnFontFamily[0];
    }
    this.footerLinksResourceEdit.userEmail = this.user;
    this.editColumnService.saveLinksResource(`/admin/footer/links/edit`, this.footerLinksResourceEdit)
      .subscribe(
        body => {
          this.showLinkEdit = false;
          this.showTextEdit = false;
          this.showImageEdit = false;
          this.dateNow = new Date();
          this.getLinksByCellId(this.cellParam.rid);
          this.getAllFooterLinksActive(this.cellParam.rid);
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Column options saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.resultImgLinkEdit = false;
          this.clear3();
        },
        error => console.error(error))
  }

  // check cekyka sakvata
  saveLinkMethod() {
    if (this.footerCellResource.rid == null) {
      this.saveErrors = true
      if (!this.addColumnForm.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }
    // image = 1, link = 2, text = 3
    if (this.footerLinksResource.footerLinksTypeResource.rid == 2) {
      this.saveErrorsLinks = true;
      if (!this.showLinkOptionsForm.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }
    if (this.footerLinksResource.footerLinksTypeResource.rid == 1) {
      if (this.footerLinksResource.imageB64 === null || this.footerLinksResource.imageB64 === undefined || this.footerLinksResource.imageB64 === "") {
        this.imageValidationImage = true;
      } else {
        this.imageValidationImage = false;
      }
      this.saveErrorsImage = true;
      if (!this.showImageOptionsForm.valid || this.imageValidationImage) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }
    if (this.footerLinksResource.footerLinksTypeResource.rid == 3) {
      this.saveErrorsText = true;
      if (!this.showTextOptionsForm.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
    }
    if (this.footerCellResource.rid == null || this.footerCellResource.rid == undefined) {
      this.saveErrors = true
      if (!this.addColumnForm.valid) {
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        return
      }
      this.showModalToAdd = true;
    } else {
      this.saveColumnOptions();
    }
  }

  // salveaza date celula si linkul
  saveLinkMethod2() {
    this.footerCellResource.userEmail = this.user;
    this.editColumnService.saveCellService(`/admin/footer/cell/edit`, this.footerCellResource)
      .subscribe(
        body => {
          this.footerCellResource = body
          this.saveColumnOptions();
          this.getLinksByCellId(this.footerCellResource.rid);
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Column saved with success!')
          ).subscribe((res) => {
            this.router.navigate(['/edit-column/' + btoa('{ "rid" : "' + this.footerCellResource.rid + '"}')]);
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.showModalToAdd = false;
        },
        error => console.error(error))
  }

  delete(elem) {
    elem.showDelete = true;
  }

  deleteFooterCellLink(rid: number) {
    this.editColumnService.deleteCellLink('/admin/footer/links/delete/' + rid + "?email=" + this.user)
      .subscribe(
        response => {
          if (response.errorCode == 0) {
            this.getAllFooterLinksActive(this.cellParam.rid);
          }
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Column content has been successfully deleted!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getLinksByCellId(this.footerCellResource.rid);
        },
        error => this.errorMessage = <any>error
      );
  }

  checkFile(event) {
    console.log(event)
    let file = event.target.files[0];
    this.isInvalidImgSize1 = false;
    this.isInvalidImgSize2 = false;
    this.isInvalidImgSize3 = false;
    this.isInvalidImgSize4 = false;
    this.isInvalidImgSize5 = false;
    this.isInvalidImgSize6 = false;
    this.isInvalidImgSize7 = false;
    this.showCropBtn1 = true;
    this.showCropBtn2 = true;
    this.showCropBtn3 = true;
    this.showCropBtn4 = true;
    this.showCropBtn5 = true;
    this.showCropBtn6 = true;
    this.showCropBtn7 = true;
    if (file.type == "image/jpeg" || file.type == "image/JPEG" || file.type == "image/jpg" || file.type == "image/JPG"
      || file.type == "image/png" || file.type == "image/PNG" || file.type == "image/gif" || file.type == "image/GIF"
      || file.type == "image/bitmap" || file.type == "image/BITMAP" || file.type == "image/tiff" || file.type == "image/TIFF") {
      if (file.size > 2000000) {
        observableForkJoin(
          this.translate.get('Error'),
          this.translate.get('Maximum size of image is 2 MB!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        event.target.value = "";
        console.log(this.cropper.image)
        if (event.currentTarget.id == 1) {
          this.isInvalidImgSize1 = true;
          this.showCropBtn1 = false;
        }
        if (event.currentTarget.id == 2) {
          this.isInvalidImgSize2 = true;
          this.showCropBtn2 = false;
        }
        if (event.currentTarget.id == 3) {
          this.isInvalidImgSize3 = true;
          this.showCropBtn3 = false;
        }
        if (event.currentTarget.id == 4) {
          this.isInvalidImgSize4 = true;
          this.showCropBtn4 = false;
        }
        if (event.currentTarget.id == 5) {
          this.isInvalidImgSize5 = true;
          this.showCropBtn5 = false;
        }
        if (event.currentTarget.id == 6) {
          this.isInvalidImgSize6 = true;
          this.showCropBtn6 = false;
        }
        if (event.currentTarget.id == 7) {
          this.isInvalidImgSize7 = true;
          this.showCropBtn7 = false;
        }
        console.log(event)
        return;
      }
      console.log()
    } else {
      observableForkJoin(
        this.translate.get('Error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF, TIFF, BITMAP!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return;
    }
    if(!this.select_option) {
      var myReader: FileReader = new FileReader();
        var image = this.element.nativeElement.querySelector('#fileupload');
        myReader.onloadend = (e: any) => {
          if (event.target.id == "poster") {
            image.src = e.target.result;
            this.footerLinksResource.imageB64 = e.target.result;
          }
        }
        myReader.readAsDataURL(file);
    }
    if(!this.select_option_edit) {
      var myReader: FileReader = new FileReader();
        var image = this.element.nativeElement.querySelector('#fileuploadedit');
        myReader.onloadend = (e: any) => {
          if (event.target.id == "poster_edit") {
            image.src = e.target.result;
            this.footerLinksResourceEdit.imageB64 = e.target.result;
          }
        }
        myReader.readAsDataURL(file);
    }
    if(!this.show) {
      var myReader: FileReader = new FileReader();
        var image = this.element.nativeElement.querySelector('#fileuploadTextIcon');
        myReader.onloadend = (e: any) => {
          if (event.target.id == "textIcon") {
            image.src = e.target.result;
            this.footerLinksResource.iconB64 = e.target.result;
          }
        }
        myReader.readAsDataURL(file);
    }
    if(!this.showEdit) {
      var myReader: FileReader = new FileReader();
        var image = this.element.nativeElement.querySelector('#fileuploadTextIconEdit');
        myReader.onloadend = (e: any) => {
          if (event.target.id == "textIconEdit") {
            image.src = e.target.result;
            this.footerLinksResourceEdit.iconB64 = e.target.result;
          }
        }
        myReader.readAsDataURL(file);
    }
  }

  // IMAGE CROPPER FOR CELL //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelect() {
    this.showButtonImage = false;
    this.showCropImage = true;
    this.croppedImg = {};
  }
  cancelImage() {
    this.showCropImage = false;
    this.showButtonImage = true;
  }
  saveImageCropped(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerCellResource.imageB64 = imgCrop;
      this.image.src = "";
      this.showCropImage = false;
      this.resultImg = true;
      this.showButtonImage = true;
    }
  }

  // IMAGE CROPPER FOR LINK //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelectLink() {
    this.showButtonImageLink = false;
    this.showCropImageLink = true;
    this.croppedImgLink = {};
  }
  cancelImageLink() {
    this.showCropImageLink = false;
    this.showButtonImageLink = true;
  }

  saveImageCroppedLink(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerLinksResource.imageB64 = imgCrop;
      this.image.src = "";
      this.showCropImageLink = false;
      this.resultImgLink = true;
      this.showButtonImageLink = true;
    }
  }

  // IMAGE CROPPER FOR LINK EDIT //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelectLinkEdit() {
    this.showButtonImageLinkEdit = false;
    this.showCropImageLinkEdit = true;
    this.croppedImgLinkEdit = {};
  }
  cancelImageLinkEdit() {
    this.showCropImageLinkEdit = false;
    this.showButtonImageLinkEdit = true;
  }

  saveImageCroppedLinkEdit(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerLinksResourceEdit.imageB64 = imgCrop;
      this.image.src = "";
      this.showCropImageLink = false;
      this.resultImgLinkEdit = true;
      this.showButtonImageLink = true;
    }
  }

  // IMAGE CROPPER FOR ICON ADD LINK //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelectIconAddLink() {
    this.showButtonImageIconAddLink = false;
    this.showCropImageIconAddLink = true;
    this.croppedImgIconAddLink = {};
  }
  cancelImageIconAddLink() {
    this.showCropImageIconAddLink = false;
    this.showButtonImageIconAddLink = true;
  }

  saveImageCroppedIconAddLink(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerLinksResource.iconB64 = imgCrop;
      this.image.src = "";
      this.showCropImageIconAddLink = false;
      this.resultImgIconAddLink = true;
      this.showButtonImageIconAddLink = true;
    }
  }

  // IMAGE CROPPER FOR ICON EDIT LINK //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelectIconEditLink() {
    this.showButtonImageIconEditLink = false;
    this.showCropImageIconEditLink = true;
    this.croppedImgIconEditLink = {};
  }
  cancelImageIconEditLink() {
    this.showCropImageIconEditLink = false;
    this.showButtonImageIconEditLink = true;
  }

  saveImageCroppedIconEditLink(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerLinksResourceEdit.iconB64 = imgCrop;
      this.image.src = "";
      this.showCropImageIconEditLink = false;
      this.resultImgIconEditLink = true;
      this.showButtonImageIconEditLink = true;
    }
  }

  // IMAGE CROPPER FOR ICON ADD TEXT //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelectIconAddText() {
    this.showButtonImageIconAddText = false;
    this.showCropImageIconAddText = true;
    this.croppedImgIconAddText = {};
  }
  cancelImageIconAddText() {
    this.showCropImageIconAddText = false;
    this.showButtonImageIconAddText = true;
  }

  saveImageCroppedIconAddText(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerLinksResource.iconB64 = imgCrop;
      this.image.src = "";
      this.showCropImageIconAddText = false;
      this.resultImgIconAddText = true;
      this.showButtonImageIconAddText = true;
    }
  }

  // IMAGE CROPPER FOR ICON EDIT TEXT //////////////////////////////////////////////////////////////////////////////////////////
  openImageSelectIconEditText() {
    this.showButtonImageIconEditText = false;
    this.showCropImageIconEditText = true;
    this.croppedImgIconEditText = {};
  }
  cancelImageIconEditText() {
    this.showCropImageIconEditText = false;
    this.showButtonImageIconEditText = true;
  }

  saveImageCroppedIconEditText(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.footerLinksResourceEdit.iconB64 = imgCrop;
      this.image.src = "";
      this.showCropImageIconEditText = false;
      this.resultImgIconEditText = true;
      this.showButtonImageIconEditText = true;
    }
  }

  cropped(bounds: Bounds) {
    console.log(bounds);
    console.log(this.cropper.image)
    if (this.isInvalidImgSize1) {
      this.clear1();
    }
    if (this.isInvalidImgSize2) {
      this.clear2();
    }
    if (this.isInvalidImgSize3) {
      this.clear3();
    }
    if (this.isInvalidImgSize4) {
      this.clear4();
    }
    if (this.isInvalidImgSize5) {
      this.clear5();
    }
    if (this.isInvalidImgSize6) {
      this.clear6();
    }
    if (this.isInvalidImgSize7) {
      this.clear7();
    }
  }

  checkEditView(links: FooterLinksResourceEdit) {
    this.showStyleOptions4Links = false;
    this.styleCheckboxSelected4Links = false;
    this.showStyleOptions4Links = false;
    this.styleCheckboxSelected4Links = false;
    this.showStyleOptions4Image = false;
    this.styleCheckboxSelected4Image = false;
    this.showStyleOptions4Text = false;
    this.styleCheckboxSelected4Text = false;

    let shouldOpenStyleBox = (
      (!isNull(links.fontFamily) && typeof(links.fontFamily) !== 'undefined' && links.fontFamily != this.columnFontFamily[0])
      || (!isNull(links.fontSize) && typeof(links.fontSize) !== 'undefined' && links.fontSize != this.columnFontSizes[0])
      || (!isNull(links.marginBottom) && typeof(links.marginBottom) !== 'undefined')
    )

    this.footerLinksListResource.footerLinksListResource.forEach(function (value) {
      if (links.rid === value.rid) {
        value.showEdit = true;
      }
      else {
        value.showEdit = false;
      }
    });
    this.footerLinksResourceEdit = Object.assign({}, links);
    if (links.footerLinksTypeResource.rid === 1) {
      this.showImageEdit = true;
      this.showLinkEdit = false;
      this.showTextEdit = false;
      if(shouldOpenStyleBox){
        this.showStyleOptions4Image = true;
        this.styleCheckboxSelected4Image = true;
      }
    }
    if (links.footerLinksTypeResource.rid === 2) {
      this.showLinkEdit = true;
      this.showTextEdit = false;
      this.showImageEdit = false;
      if(shouldOpenStyleBox){
        this.showStyleOptions4Links = true;
        this.styleCheckboxSelected4Links = true;
      }
    }
    if (links.footerLinksTypeResource.rid === 3) {
      this.showTextEdit = true;
      this.showImageEdit = false;
      this.showLinkEdit = false;
      if(shouldOpenStyleBox){
        this.showStyleOptions4Text = true;
        this.styleCheckboxSelected4Text = true;
      }
    }

    (this.footerLinksResourceEdit.marginBottom)&&(this.footerLinksResourceEdit.marginBottom = this.footerLinksResourceEdit.marginBottom.split('px')[0])
    if(isNull(this.footerLinksResourceEdit.fontFamily) || typeof(this.footerLinksResourceEdit.fontFamily) == 'undefined'){
      this.footerLinksResourceEdit.fontFamily = this.columnFontFamily[0];
    }
    if(isNull(this.footerLinksResourceEdit.fontSize) || typeof(this.footerLinksResourceEdit.fontSize) == 'undefined'){
      this.footerLinksResourceEdit.fontSize = this.columnFontSizes[0];
    }
  }

  endShift(htmlRef) {
    let rid = htmlRef[1].getAttribute("homepage-rid")
    let oldPos = parseInt(htmlRef[1].getAttribute("index"))
    let newPos = undefined
    let homepageList = htmlRef[2].children;

    for (let i = 0; i < homepageList.length; i++) {
      let k = homepageList[i].getAttribute("homepage-rid")
      if (rid == k) {
        newPos = i
        break;
      }
    }

    console.log("----------------", newPos, oldPos)
    this.editColumnService.shiftElements(`/admin/footer/links/shift?cellId=` + this.cellParam.rid + "&oldPosition=" + oldPos + "&newPosition=" + newPos + "&email=" + this.user, null)
      .subscribe(
        response => {
          this.footerLinksListResourceActive = response;
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Elements shifted with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getAllFooterLinksActive(this.cellParam.rid);
        },
        error => this.errorMessage = <any>error);
  }


  getAllFooterLinksActive(rid: number) {
    this.editColumnService.getAllActiveLinks('/admin/footer/links/getActiveByCell/' + rid + "?email=" + this.user)
      .subscribe(
        body => {
          this.footerLinksListResourceActive = body;
          if (this.footerLinksListResourceActive != null) {
            if (this.footerLinksListResourceActive.footerLinksListResource != null) {
              let count = this.footerLinksListResourceActive.footerLinksListResource.length;
              if (count >= 2) {
                this.showShiftBtn = true;
              } else {
                this.showShiftBtn = false;
              }
            } else {
              this.showShiftBtn = false;
            }
          }
        },
        error => this.errorMessage = <any>error)
  }

  closeLink() {
    this.showLinkOptions = false
    this.showContentForAdd = false
    this.footerLinksResource = new FooterLinksResource();
    this.footerLinksResource.footerLinksTypeResource = new FooterLinksTypeResource();
  }
  closeText() {
    this.showTextOptions = false
    this.showContentForAdd = false
    this.footerLinksResource = new FooterLinksResource();
    this.footerLinksResource.footerLinksTypeResource = new FooterLinksTypeResource();
  }
  closeImage() {
    this.showImageOptions = false
    this.showContentForAdd = false
    this.footerLinksResource = new FooterLinksResource();
    this.footerLinksResource.footerLinksTypeResource = new FooterLinksTypeResource();
  }
  cancelShifting() {
    this.contentShift = false;
  }

  getAllActiveLinksButton() {
    this.contentShift = true;
    this.getAllFooterLinksActive(this.cellParam.rid);
  }

  checkContentSelected() {
    if (this.footerCellResource.footerCellTypeResource.rid == 2) {
      this.showContent = true;
    } else {
      this.showContent = false;
    }
  }

  cancel() {
    this.router.navigate(['/view-footer-columns']);
  }

  change(evt) {
		this.show = evt.target.checked
		console.log(evt.target.checked);
		if (this.show) {
			this.footerLinksResource.iconB64 = "";
		}
	}

  changeEdit(evt) {
		this.showEdit = evt.target.checked
		console.log(evt.target.checked);
		if (this.showEdit) {
			this.footerLinksResourceEdit.iconB64 = "";
		}
	}

}
